// Morning Briefing — the model picture of one row: 112 x 84, white, flush to the row's left edge.
// Same reader as every screen (src/hooks/useModelPhotos: library, Sales master, dev card, sample sheet; drawn by ModelPhotoImg).
// Four honest states: loading (quiet blank), ok, none ("No photo yet"), error ("Photo unavailable"). Never an empty hole.
import React from 'react';
// CSS order: the Acetate bank chunk loads acetateBank.module.css before ProductImg.module.css (see ModelPhoto.js in Orders Models).
import '../../../portals/data/acetateBank/acetateBank.module.css';
import ModelPhotoImg from '../ModelPhotoImg';
import { IcZoom } from './briefingIcons';
import styles from './briefingRows.module.css';

function NoPhoto({ word, title }) {
  return (
    <div className={styles.noPhoto} data-photo="none" title={title}>
      <svg viewBox="0 0 48 18" aria-hidden="true">
        <g fill="none" stroke="#bdb5a7" strokeWidth="1.2" strokeDasharray="2.2 2"><rect x="2" y="3" width="17" height="12" rx="5" /><rect x="29" y="3" width="17" height="12" rx="5" /></g>
        <path d="M19.5 7.5Q24 4.8 28.5 7.5" fill="none" stroke="#bdb5a7" strokeWidth="1.2" />
      </svg>
      <span>{word}</span>
    </div>
  );
}

export default function BriefingPhoto({ photo, code, onZoom }) {
  const st = !code ? 'nocode' : photo ? photo.state : 'none';
  if (st === 'loading') return <div className={styles.photoWait} data-photo="loading" aria-hidden="true" />;
  if (st === 'ok') {
    const img = (
      <ModelPhotoImg photo={photo} alt={`${code} photo`} className={styles.photoImg}
        fallback={<NoPhoto word="No photo yet" title={`The picture of ${code} could not be loaded`} />} />
    );
    // a click makes it bigger (BriefingZoom); the row's own actions are untouched
    return onZoom ? (
      <button type="button" className={styles.zoomBtn} onClick={onZoom} aria-label={`Enlarge the photo of ${code}`} title="Bigger" data-test="briefing-zoom">
        {img}<span className={styles.zoomIc}><IcZoom /></span>
      </button>
    ) : img;
  }
  if (st === 'error') return <NoPhoto word="Photo unavailable" title={`The picture of ${code} could not be read`} />;
  return <NoPhoto word={st === 'nocode' ? 'No model' : 'No photo yet'} title={st === 'nocode' ? 'This note is not about one model' : `No photo for ${code} yet`} />;
}
